<template>
  <div>
    <banner-toolbar />
    <v-container class="pa-16">
      <header-title :title="title" />
      <div class="mt-6">
        <div
          v-for="(phase, index) in phases"
          v-bind:key="index"
          class="d-flex align-center"
        >
          <v-checkbox
            color="accent"
            v-model="phase.checked"
            readonly
          ></v-checkbox>
          <div class="ml-2 primaryText--text body-2 font-weight-medium">
            {{ phase.title + ":" }}
          </div>
          <div class="body-2 ml-2">{{ phase.text }}</div>
        </div>
        <v-btn
          to="/profile"
          replace
          @click="nextClicked"
          :width="150"
          color="accent"
          class="mt-6"
          >Next</v-btn
        >
      </div>
    </v-container>
    <!-- <v-container fluid class="pt-16">
      <v-row justify="center">
        <v-col cols="8">
          <v-row class="mb-6">
            <header-title :title="title"></header-title>
          </v-row>
          <v-row align="start" justify="start" v-for="(phase, index) in phases" v-bind:key="index">
            <v-checkbox color="accent" v-model="phase.checked" readonly class="ma-0 pa-0"></v-checkbox>
            <div class="ml-2 primaryText--text body-2 font-weight-medium">{{ phase.title + ":" }}</div>
            <div class="body-2 ml-2">{{ phase.text }}</div>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-4" justify="center">
          <v-col sm="4" md="2" xs="4">
              <v-row align="center">
                <v-btn 
                    to="/profile" 
                    replace 
                    class="full-width" 
                    @click="nextClicked"
                    color="accent">Next</v-btn>              
              </v-row>
          </v-col>
      </v-row>
    </v-container> -->
  </div>
</template>

<script>
import HeaderTitle from "../components/HeaderTitle";
import BannerToolbar from "../components/BannerToolbar";

export default {
  name: "InstructionsScreen",
  components: {
    HeaderTitle,
    BannerToolbar
  },
  created() {},
  data() {
    return {
      title:
        "You will be guided through the application process that will follow these steps.",
      phases: [
        {
          title: "Phase 1",
          text: "Create your Profile",
          checked: true
        },
        {
          title: "Phase 2",
          text: "Meet required Eligibility Requirements",
          checked: true
        },
        {
          title: "Phase 3",
          text: "Upload required documents",
          checked: true
        },
        {
          title: "Phase 4",
          text: "Submit complete application",
          checked: true
        },
        {
          title: "Phase 5",
          text: "Informed of Results",
          checked: true
        }
      ]
    };
  },
  methods: {
    nextClicked() {}
  }
};
</script>
